//@ 清除指定文字
export const cleanKeyword = (text: string, keyword: string): string => {
  if (!text) return "";
  if (!keyword) return text.trim();

  const escapedKeyword = keyword.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const regex = new RegExp(escapedKeyword, "gi");

  return text.replace(regex, "").replace(/\s+/g, " ").trim();
};
